/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'teaching': {
    width: 212.5,
    height: 200,
    viewBox: '0 0 1088 1024',
    data: '<defs/><path pid="0" d="M488.64 977.28H54.272A54.272 54.272 0 010 922.88v-760h1085.824v760c0 30.016-24.32 54.272-54.272 54.272H488.64zM108.608 868.672h868.608V271.488H108.608v597.12zm488.512-488.64h271.488V488.64H597.12V380.032zm0 217.152h271.488v108.608H597.12V597.12zM380.032 380.032v162.88h162.88a162.88 162.88 0 11-162.88-162.88zM0 0h1085.824v108.608H0V0z" _fill="#cdcdcd"/>'
  }
})
